import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TableColumnType } from '@/components';
import { ItemTableRowValues } from './ItemListTabPanelGridView';
import { ItemIcon } from '../Items/ItemIcon';
import { Space } from 'antd';

export function useGeoItemsColumns() {
  const { t } = useTranslation();

  return useMemo<TableColumnType<ItemTableRowValues>[]>(() => {
    const columns: Array<TableColumnType<ItemTableRowValues> | false> = [
      {
        title: t('items.table.category'),
        key: 'category',
        render: (_, { categories, item }) =>
          categories.length > 1 || item ? undefined : categories[0].name,
        width: '15%',
      },
      {
        title: t('items.table.subcategory1'),
        key: 'subcategory1',
        render: (_, { categories, item }) =>
          categories.length > 2 || item ? undefined : categories[1]?.name,
        width: '12%',
      },
      {
        title: t('items.table.subcategory2'),
        key: 'subcategory2',
        render: (_, { categories, item }) =>
          item ? undefined : categories[2]?.name,
        width: '12%',
      },
      {
        title: t('items.table.name'),
        key: 'name',
        render: (_, { item }) =>
          item?.name && (
            <Space>
              <ItemIcon color="#107cc7" verticalAlign="middle" />
              {item.name}
            </Space>
          ),
      },
    ];
    return columns.filter((x) => !!x) as TableColumnType<ItemTableRowValues>[];
  }, [t]);
}
